'use client';

import React from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import {
  Car,
  Users,
  Plane,
  Building2,
  Heart,
  GraduationCap,
  Briefcase,
  PartyPopper,
  Bus,
  MapPin,
  Truck,
  Package,
} from 'lucide-react';

interface ServiceItem {
  icon: React.ReactNode;
  title: string;
  description: string;
  features: string[];
  highlight?: boolean;
}

const services: ServiceItem[] = [
  {
    icon: <Car size={28} />,
    title: 'Rental Mobil Dengan Driver',
    description:
      'Nikmati perjalanan nyaman dengan driver profesional berpengalaman. Cocok untuk perjalanan bisnis, wisata, maupun keperluan pribadi.',
    features: [
      'Driver berpengalaman & berlisensi',
      'Armada terawat & bersih',
      'Tepat waktu & terpercaya',
      'Tersedia 24 jam',
    ],
    highlight: true,
  },
  {
    icon: <Car size={28} />,
    title: 'Rental Mobil Tanpa Driver',
    description:
      'Kebebasan berkendara dengan armada pilihan kami. Tersedia berbagai pilihan kendaraan sesuai kebutuhan Anda.',
    features: [
      'Syarat & ketentuan berlaku',
      'Pilihan armada lengkap',
      'Harga kompetitif',
      'Proses mudah & cepat',
    ],
  },
  {
    icon: <Bus size={28} />,
    title: 'Rental Hiace',
    description:
      'Solusi transportasi kelompok dengan Toyota Hiace Commuter & Premio. Kapasitas 14–15 penumpang, nyaman untuk perjalanan jauh.',
    features: [
      'Hiace Commuter 15 seat',
      'Hiace Premio 14 seat',
      'AC dingin & nyaman',
      'Cocok perjalanan jauh',
    ],
  },
  {
    icon: <Bus size={28} />,
    title: 'Rental Elf',
    description:
      'Elf Long kapasitas 19 penumpang, ideal untuk rombongan kecil hingga menengah dengan harga terjangkau.',
    features: [
      'Elf Long 19 seat',
      'Ekonomis & efisien',
      'Cocok wisata & acara',
      'Driver berpengalaman',
    ],
  },
  {
    icon: <Bus size={28} />,
    title: 'Rental Medium Bus',
    description:
      'Medium Bus kapasitas 31–35 penumpang untuk kebutuhan transportasi rombongan menengah.',
    features: [
      'Kapasitas 31–35 penumpang',
      'AC & fasilitas lengkap',
      'Cocok study tour',
      'Harga terjangkau',
    ],
  },
  {
    icon: <Bus size={28} />,
    title: 'Rental Big Bus',
    description:
      'Big Bus kapasitas 50–59 penumpang untuk rombongan besar. Ideal untuk wisata, event, dan perjalanan perusahaan.',
    features: [
      'Kapasitas 50–59 penumpang',
      'Fasilitas premium',
      'Cocok event besar',
      'Armada terawat',
    ],
  },
  {
    icon: <Plane size={28} />,
    title: 'Airport Transfer',
    description:
      'Layanan jemput & antar bandara yang tepat waktu dan profesional. Tersedia untuk semua bandara di Jabodetabek.',
    features: [
      'Tepat waktu & terpercaya',
      'Pemantauan jadwal penerbangan',
      'Meet & greet tersedia',
      'Tersedia 24 jam',
    ],
  },
  {
    icon: <Building2 size={28} />,
    title: 'Corporate Transport',
    description:
      'Solusi transportasi korporat untuk kebutuhan perusahaan Anda. Kontrak bulanan & tahunan tersedia.',
    features: [
      'Kontrak bulanan/tahunan',
      'Armada dedicated',
      'Laporan perjalanan',
      'Tagihan terpusat',
    ],
    highlight: true,
  },
  {
    icon: <Heart size={28} />,
    title: 'Wedding Transport',
    description:
      'Layanan transportasi pernikahan yang elegan dan berkesan. Armada premium untuk hari spesial Anda.',
    features: [
      'Dekorasi kendaraan',
      'Armada premium',
      'Koordinasi acara',
      'Tepat waktu & rapi',
    ],
  },
  {
    icon: <MapPin size={28} />,
    title: 'Wisata & Tour',
    description:
      'Paket wisata dengan armada nyaman dan driver yang hafal rute wisata populer di Jabodetabek & sekitarnya.',
    features: [
      'Driver hafal rute wisata',
      'Armada nyaman & bersih',
      'Fleksibel & customizable',
      'Harga paket tersedia',
    ],
  },
  {
    icon: <GraduationCap size={28} />,
    title: 'Study Tour',
    description:
      'Transportasi study tour untuk sekolah dan universitas. Armada bus & Hiace tersedia dengan harga khusus institusi.',
    features: [
      'Harga khusus institusi',
      'Bus & Hiace tersedia',
      'Koordinasi dengan sekolah',
      'Keamanan prioritas',
    ],
  },
  {
    icon: <PartyPopper size={28} />,
    title: 'Event & Exhibition',
    description:
      'Transportasi untuk event, pameran, dan konferensi. Layanan shuttle dan antar-jemput peserta tersedia.',
    features: [
      'Shuttle service',
      'Antar-jemput peserta',
      'Koordinasi event',
      'Armada fleksibel',
    ],
  },
  {
    icon: <Briefcase size={28} />,
    title: 'Perjalanan Dinas',
    description:
      'Layanan transportasi perjalanan dinas yang profesional dan terpercaya untuk kebutuhan bisnis Anda.',
    features: [
      'Laporan perjalanan',
      'Invoice resmi',
      'Driver profesional',
      'Tersedia 24 jam',
    ],
  },
  {
    icon: <Users size={28} />,
    title: 'Antar Jemput Karyawan',
    description:
      'Solusi transportasi karyawan yang efisien dan terjadwal. Tersedia untuk perusahaan dengan kebutuhan reguler.',
    features: [
      'Jadwal tetap & fleksibel',
      'Rute customizable',
      'Absensi digital',
      'Laporan bulanan',
    ],
  },

  // TAMBAHAN BARU
  {
    icon: <Truck size={28} />,
    title: 'Rental Pickup',
    description:
      'Layanan rental kendaraan pickup double cabin untuk kebutuhan operasional, perjalanan proyek, maupun kebutuhan perusahaan.',
    features: [
      'Hilux Double Cabin',
      'Hilux Rabgga',
      'Triton Double Cabin',
      'Cocok untuk operasional & proyek',
      'Tersedia dengan driver',
    ],
  },
  {
    icon: <Package size={28} />,
    title: 'Rental Mobil Box & Blind Van',
    description:
      'Solusi transportasi untuk pengiriman barang, distribusi, logistik, dan kebutuhan operasional bisnis dengan berbagai pilihan kapasitas kendaraan.',
    features: [
      'CDD Box 5.000 kg',
      'CDE Box 2.200 kg',
      'Box Kecil 1.000 kg',
      'Blind Van 720 kg',
    ],
    highlight: true,
  },
];

export default function LayananPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-28 pb-16 bg-primary overflow-hidden">
        <div className="absolute inset-0 bg-hero-pattern" />
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-64 h-64 rounded-full border border-accent/30" />
          <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full border border-accent/20" />
        </div>

        <div className="relative max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 text-center">
          <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-4 py-1.5 mb-5">
            <span className="text-accent text-xs font-bold uppercase tracking-widest">
              Layanan Kami
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4 leading-tight">
            Solusi Transportasi
            <br />
            <span className="text-gradient-gold">Lengkap & Profesional</span>
          </h1>

          <p className="text-white/70 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            Dari rental harian hingga kontrak korporat, kami menyediakan berbagai
            layanan transportasi untuk memenuhi setiap kebutuhan perjalanan Anda.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 lg:py-20">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, idx) => (
              <div
                key={`service-${idx}`}
                className={`relative rounded-xl border p-6 transition-all duration-300 group hover:-translate-y-1 ${
                  service.highlight
                    ? 'bg-primary border-accent/40 shadow-lg'
                    : 'bg-white border-border hover:border-accent/40 hover:shadow-lg'
                }`}
              >
                {service.highlight && (
                  <div className="absolute top-4 right-4">
                    <span className="bg-accent text-primary text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
                      Populer
                    </span>
                  </div>
                )}

                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${
                    service.highlight
                      ? 'bg-accent/20 text-accent'
                      : 'bg-primary/8 text-primary'
                  }`}
                >
                  {service.icon}
                </div>

                <h3
                  className={`font-bold text-lg mb-2 ${
                    service.highlight ? 'text-white' : 'text-foreground'
                  }`}
                >
                  {service.title}
                </h3>

                <p
                  className={`text-sm leading-relaxed mb-4 ${
                    service.highlight
                      ? 'text-white/65'
                      : 'text-muted-foreground'
                  }`}
                >
                  {service.description}
                </p>

                <ul className="space-y-1.5 mb-5">
                  {service.features.map((feat, fi) => (
                    <li
                      key={`feat-${idx}-${fi}`}
                      className="flex items-center gap-2"
                    >
                      <div className="w-1.5 h-1.5 rounded-full shrink-0 bg-accent" />
                      <span
                        className={`text-xs ${
                          service.highlight
                            ? 'text-white/70'
                            : 'text-muted-foreground'
                        }`}
                      >
                        {feat}
                      </span>
                    </li>
                  ))}
                </ul>

                <Link
                  href="/booking-page"
                  className={`inline-flex items-center gap-1.5 text-sm font-bold transition-colors ${
                    service.highlight
                      ? 'text-accent hover:text-accent-light'
                      : 'text-primary hover:text-accent'
                  }`}
                >
                  Booking Sekarang →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 bg-primary">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 text-center">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-3">
            Butuh Layanan Khusus?
          </h2>

          <p className="text-white/65 mb-7 max-w-xl mx-auto">
            Hubungi kami untuk mendiskusikan kebutuhan transportasi Anda. Kami siap
            memberikan solusi terbaik.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              href="/booking-page"
              className="btn-primary px-8 py-3.5 rounded-lg font-bold text-sm"
            >
              BOOKING SEKARANG
            </Link>

            <a
              href="https://wa.me/6287786556067"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline-gold px-8 py-3.5 rounded-lg font-bold text-sm"
            >
              CHAT WHATSAPP
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
